export const getCookieValue = (name: string) => {
  // Create a name pattern to search for, with "=" appended
  const namePattern = `${name}=`;
  // Decode the cookie string to handle cookies with special characters
  const decodedCookie = decodeURIComponent(document.cookie);
  // Split the cookie string into individual cookies
  const cookies = decodedCookie.split(";");

  // Iterate over all cookies
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    // If the cookie starts with the name pattern, extract its value
    if (cookie.indexOf(namePattern) === 0) {
      return cookie
        .substring(namePattern.length, cookie.length)
        .split(",")
        .filter((cookie) => cookie !== "")
        .join(",");
    }
  }

  // If the cookie with the specified name is not found, return null
  return null;
};
